import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProposalTable from "./ProposalTable";

function ViewProposalsTab(props) {
    const [activeProposals, setActiveProposals] = useState([])
    const getProposals = async () => {
        let proposals = await props.lockbox.methods.viewActiveProposals().call({ from: props.address });
        setActiveProposals(proposals)
      }

    return (
        <div>
            <Button variant="dark" onClick={getProposals}>Retrieve All Proposals</Button>
            <br />
            <br />
            <h3>Currently Active Proposals</h3>
            <ProposalTable proposals={activeProposals} />
        </div>
    )
}

export default ViewProposalsTab
